import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { IconLoader } from 'common/IconLoader';
import SvgAF, { IconAndText } from 'components/shared/SvgAF/SvgAF';
import { PerfectScrollbar } from 'components/shared/ReactPerfectScrollbar';
import { deviceToProductTypeDisplayString } from 'common/utils/helpers';
import DropModal from 'components/shared/DropModal/DropModal';
import { deviceTypeToIcon } from 'components/features/DeviceView/DeviceAlarms/utils';
import { setDropModalOpen } from 'redux/actions';
import styles from './ChartExplorerPageRecentViewedDeviceMenu.module.css';

const DROP_MODAL_NAME = 'RecentViewedDeviceMenu';

const ChartExplorerPageRecentViewedDeviceMenu = ({ onChange, options }) => {
  const dispatch = useDispatch();
  const handleClick = useCallback(
    (deviceId) => {
      dispatch(setDropModalOpen(DROP_MODAL_NAME, false));
      onChange(deviceId);
    },
    [dispatch, onChange]
  );

  return (
    <DropModal
      className={styles.dropModal}
      name={DROP_MODAL_NAME}
      title={
        <SvgAF
          img={IconLoader.icon_recently_viewed}
          hover={IconLoader.icon_recently_viewed_hover}
          tooltip={'Recently viewed devices'}
        />
      }
    >
      <div className={styles.menu}>
        <PerfectScrollbar>
          <div className={styles.menuList}>
            <span className={styles.menuHeader}>Recently viewed</span>
            {options.length > 0 ? (
              options.map((device) => (
                <RecentViewedDeviceMenuItem key={device.id} device={device} onClick={handleClick} />
              ))
            ) : (
              <div className={styles.noRecentViewed}>No recently viewed devices</div>
            )}
          </div>
        </PerfectScrollbar>
      </div>
    </DropModal>
  );
};

export default ChartExplorerPageRecentViewedDeviceMenu;

function RecentViewedDeviceMenuItem({ device, onClick }) {
  const deviceId = device.id ?? device.deviceId;
  const deviceType = deviceToProductTypeDisplayString(device);

  return (
    <span onClick={() => onClick(deviceId)}>
      <IconAndText
        customClass={styles.iconAndTextItem}
        img={deviceTypeToIcon[deviceType] || IconLoader.icon_donor}
        text={deviceId}
      />
    </span>
  );
}
